/**
 * Synapsy Widget - Acessibilidade
 * Helpers para tornar elementos não-nativos (div/span com role="button")
 * operáveis por teclado, com paridade ao clique do mouse.
 */

/**
 * Aciona `handler` no clique OU no teclado (Enter/Espaço). Use em elementos
 * com role="button" para que usuários de teclado tenham o mesmo comportamento
 * do clique. Também define tabindex="0" (se ainda não houver) para deixá-los
 * focáveis via Tab.
 * @param {HTMLElement} el
 * @param {(event: Event) => void} handler
 */
export function onActivate(el, handler) {
  if (!el.hasAttribute("tabindex")) {
    el.setAttribute("tabindex", "0");
  }
  el.addEventListener("click", handler);
  el.addEventListener("keydown", (event) => {
    // " " é o valor padrão da tecla Espaço (mantemos preventDefault para não
    // rolar a página); Enter também aciona.
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler(event);
    }
  });
}
